import { Spinner } from './primitives';
export const LoadingScreen = (): import("react").JSX.Element => <div className="application-state-screen"><div><Spinner size="lg" label="Loading Lattice" /><p>Loading Lattice ...</p></div></div>;
